import React from 'react';
import { BooleanFilterGq } from '../../../../graphql/projects/models/BooleanFilterGq';
import { HeadCellImplementationProps } from '../KeywordTable/HeadCells/models';
import { Box, List, ListItem, ListItemText } from '@material-ui/core';
import VoxelMenuItemContainer from '../../../voxel/PopoverMenu/VoxelMenuItemContainer';
import HeadCell from './HeadCell';
import HeadCellStandardOptions from './HeadCellStandardOptions';

export interface HeadCellBooleanProps extends HeadCellImplementationProps {
  // Filter state
  state?: BooleanFilterGq;
  setState?: (state?: BooleanFilterGq) => void;
}

export const HeadCellBoolean: React.FC<HeadCellBooleanProps> = ({
  state,
  setState,
  basicConfig,
  basicState,
}) => {
  return (
    <HeadCell
      hasFilter={state !== undefined}
      align="left"
      basicConfig={basicConfig}
      basicState={basicState}
    >
      <VoxelMenuItemContainer size="md">
        <HeadCellStandardOptions basicConfig={basicConfig} basicState={basicState} />
        <Box p={1} py={1.5}>
          <List dense>
            <ListItem
              selected={state === BooleanFilterGq.EMPTY}
              button
              onClick={() =>
                setState(state === BooleanFilterGq.EMPTY ? undefined : BooleanFilterGq.EMPTY)
              }
            >
              <ListItemText primary="N/A" />
            </ListItem>
            <ListItem
              selected={state === BooleanFilterGq.TRUE}
              button
              onClick={() =>
                setState(state === BooleanFilterGq.TRUE ? undefined : BooleanFilterGq.TRUE)
              }
            >
              <ListItemText primary="Yes" />
            </ListItem>

            <ListItem
              selected={state === BooleanFilterGq.FALSE}
              button
              onClick={() =>
                setState(state === BooleanFilterGq.FALSE ? undefined : BooleanFilterGq.FALSE)
              }
            >
              <ListItemText primary="No" />
            </ListItem>
          </List>
        </Box>
      </VoxelMenuItemContainer>
    </HeadCell>
  );
};

export default HeadCellBoolean;
